import React, { useEffect, useState } from "react";
import { FaInfoCircle, FaSignInAlt, FaListOl } from "react-icons/fa";
import Login from "../components/Login";

import apiRequest from "../services/api";
import ResetPassword from "../components/ResetPassword";

const HomePage = () => {
  const [instructions, setInstructions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const token = localStorage.getItem("token");
  const [isForgotModalOpen, setIsForgotModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    // 1. Retrieve the saved user object
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        setCurrentUser(user);

        // 2. Check if user.akey is not equal to 0
        const akey = Number(user?.akey ?? 0);
        if (akey !== 0) {
          setIsForgotModalOpen(true);
        }
      } catch (err) {
        console.error("Failed to parse stored user data:", err);
      }
    }
  }, []);

  /* ==========================
     AUTH CHECK
  ========================== */
  useEffect(() => {
    if (!token) {
      setShowLoginModal(true);
      setLoading(false);
    } else {
      setShowLoginModal(false);
    }
  }, [token]);

  /* ==========================
     FETCH INSTRUCTIONS
  ========================== */
  useEffect(() => {
    const fetchInstructions = async () => {
      setLoading(true);
      setError(null);

      try {
        const json = await apiRequest(`users/note`, {});

        if (json.success) {
          setInstructions(json.data || []);
        } else {
          throw new Error(json.message || "Failed to load instructions");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchInstructions();
  }, []);

  /* ==========================
     EARLY RETURNS
  ========================== */
  if (showLoginModal) {
    return (
      <Login
        onClose={() => setShowLoginModal(false)}
        onLogin={() => setShowLoginModal(false)}
      />
    );
  }

  if (loading) {
    return (
      <div className="p-12 text-center animate-pulse text-gray-600">
        Loading instructions...
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-12 text-center text-red-600 font-semibold">{error}</div>
    );
  }

  /* ==========================
     RENDER
  ========================== */
  return (
    <section className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 py-12 px-6">
      <div className="max-w-5xl mx-auto space-y-10">
        {/* HEADER */}
        <div className="text-center space-y-3">
          <div className="flex justify-center text-indigo-600 text-5xl">
            <FaInfoCircle />
          </div>
          <h1 className="text-3xl md:text-4xl font-extrabold text-gray-800">
            Notifications
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Please carefully follow the folowing instructions.
          </p>
        </div>

        {/* INSTRUCTIONS LIST */}
        <div className="md:col-span-2">
          <textarea
            name="registrationNotice"
            value={instructions || ""}
            rows={50}
            className="w-full border rounded px-3 py-2 focus:ring-2 focus:ring-blue-400"
          />
        </div>

        {/* FOOTER NOTE */}
        <div className="bg-white border rounded-xl p-6 shadow-sm flex gap-4 items-start">
          <FaSignInAlt className="text-indigo-600 text-2xl mt-1" />
          <div>
            <h4 className="font-semibold text-gray-800">Important Note</h4>
            <p className="text-gray-600 text-sm mt-1">
              Ensure all information provided is accurate. Incorrect or
              incomplete submissions may result in disqualification.
            </p>
          </div>
        </div>
      </div>
      <ResetPassword
        isOpen={isForgotModalOpen}
        onClose={() => setIsForgotModalOpen(false)}
        initialUsername={currentUser?.username || ""}
      />
    </section>
  );
};

/* ==========================
   COMPONENTS
========================== */

const InstructionCard = ({ step, title, description }) => (
  <div className="bg-white p-6 rounded-2xl shadow border hover:shadow-md transition">
    <div className="flex items-center gap-4 mb-4">
      <div className="w-10 h-10 rounded-full bg-indigo-600 text-white flex items-center justify-center font-bold">
        {step}
      </div>
      <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
    </div>
    <p className="text-gray-600 text-sm leading-relaxed">{description}</p>
  </div>
);

export default HomePage;
